import React, {h, Component} from 'preact';
import MenuObject from '../canvas/menu-object';
import {connect} from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import store from "../store";
import MenuContentEditItem from "./MenuContentEditItem";
import MenuObjectEditNameNotes from './MenuObjectEditNameNotes';
import TrashIcon from "./svg/TrashIcon";
import BackArrow from "./svg/BackArrow";
import NextArrow from "./svg/NextArrow";

export default @connect(reduce, actions)
class AsideMenuObjectEdit extends Component {
    constructor() {
        super()
        this.state = {
            objects: [],
            editSubtype: "item",
        };

        this.setEditSubtype = (subtype) => {
            this.setState({editSubtype: subtype});
        }
    }

    goToPrevItem() {
        MenuObject.moPaginationPrev();
    }

    goToNextItem() {
        MenuObject.moPaginationNext();
    }

    deleteItem() {
        MenuObject.moPaginationDelete();
    }

    closeModal() {
        $('.aside-mo-top .bar').trigger('click');
    }

    render(props, state) {
        const $element = props.$element;
        const activeIdx = store.getState().moSelectedItemIdx || 0;
        return (
            <div className="aside-mo-edit menu-object-content">
                {props.MOEditMode === "items" && <div>
                    <MenuContentEditItem
                        $element={$element}
                        activeIdx={activeIdx}
                        active={store.getState().menuObjectItems[activeIdx]}
                        contentEditMode={state.editSubtype}
                        setContentEditMode={this.setEditSubtype}
                        uploadedIcons={props.uploadedIcons}
                        setUploadedIcons={props.setUploadedIcons}
                    />
                </div>}
                {props.MOEditMode === "name-notes" &&
                <MenuObjectEditNameNotes $element={$element} closeModal={this.closeModal} isMobileVersion={props.isMobileVersion} />}
                <div className={'pagination'}>
                    <div className={'prev'} onClick={this.goToPrevItem}><BackArrow/></div>
                    <div className={'delete'} onClick={this.deleteItem}><a className={'btn medium secondary4'}><TrashIcon/> Delete</a></div>
                    <div className={'done'} onClick={this.closeModal}><a className={'btn medium primary'}>Done</a></div>
                    <div className={'next'} onClick={this.goToNextItem}><NextArrow/></div>
                </div>
            </div>
        )
    }
}
